import React from 'react'
import { Alert, Button, Snackbar } from '@mui/material'
import { useRegisterSW } from 'virtual:pwa-register/react'

const ReloadPrompt: React.FC = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      window.console.log('SW Registered:', r)
    },
    onRegisterError(error) {
      window.console.log('SW registration error', error)
    },
  })

  const handleUpdate = () => {
    updateServiceWorker(true)
  }

  const handleClose = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  return (
    <Snackbar autoHideDuration={6000} onClose={handleClose} open={offlineReady || needRefresh}>
      <Alert
        action={
          needRefresh ? (
            <Button color={'inherit'} onClick={handleUpdate} size={'small'}>
              {'Reload\r'}
            </Button>
          ) : null
        }
        onClose={handleClose}
        severity={'info'}
      >
        {offlineReady
          ? 'App is ready to work offline'
          : 'New content available, click reload to update.'}
      </Alert>
    </Snackbar>
  )
}

export default ReloadPrompt
